import * as angular from 'angular';
import { Constants as constants } from '../../constants';
import { FeesRepo as feesRepo } from './fees.repo';
import { fees } from './fees';
import {feeTypeManagement} from './feeTypeManagement/fees.feetype.management'
import {addFeeTypeDialog} from './feeTypeManagement/addFeeTypeDialog/addFeeType.dialog'
import {clientFeeManagement} from './clientFeeManagement/fees.clientFeeManagement'
import {createPortfolioFeeDialog} from './clientFeeManagement/createPortfolioFeeDialog/createPortfolioFee.dialog'
import {createPortfolioFeeExclusionDialog} from './clientFeeManagement/createFeeExclusion/createPortfolioFeeExclusion.dialog'
import {managementFeeCashAccount} from './cashAccounts/fees.cashaccounts'
import {instructions} from './instructions/fees.instructions'
import {tempRun} from './instructions/temprun/fees.instructions.temprun'
import {finalRun} from './instructions/finalrun/fees.instructions.finalrun'
import {generateInstructionSheetDialog} from  './instructions/finalrun/generateInstructionSheetDialog/instruction.generateInstructionSheet.dialog'
import {instructionSheet} from './instructions/instructionSheets/fees.instructions.sheets'
export const feesModule = 'fees';

angular
  .module(feesModule, ['xeditable'])
  .constant("config", constants.Default)
  .service('feesRepo', feesRepo)
  .component('fees', fees)
  .component('feeTypeManagement',feeTypeManagement)
  .component('addFeeTypeDialog',addFeeTypeDialog)
  .component('clientFeeManagement',clientFeeManagement)
  .component('createPortfolioFeeDialog',createPortfolioFeeDialog)
  .component('createPortfolioFeeExclusionDialog',createPortfolioFeeExclusionDialog)
  .component('managementFeeCashAccount' , managementFeeCashAccount)
  .component('instructions', instructions)
  .component('tempRun',tempRun)
  .component('finalRun', finalRun)
  .component('generateInstructionSheetDialog',generateInstructionSheetDialog)
  .component('instructionSheet', instructionSheet)



// WEBPACK FOOTER //
// ./src/app/fees/fees.index.ts